module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-f920b7944789f4b41be1ba16f3bd3c15.webp";